"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var const_1 = require("../../const");
var prosemirror_state_1 = require("prosemirror-state");
var decoration_1 = require("../decoration");
var browser_1 = require("../../libs/browser");
var chainClickEvent = function (params) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return Array.from(args).some(function (handler) { return handler(params); });
};
exports.chainClickEvent = chainClickEvent;
var chainKeyDownEvent = function (view, event) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return Array.from(args).some(function (handler) { return handler({ view: view, event: event }); });
};
exports.chainKeyDownEvent = chainKeyDownEvent;
var checkIsRawBlock = function (node) { return node && node.isBlock && !node.isTextblock; };
// 前后都不能输入文字的情况下插入一个空行
var insertPWhenBlock = function (view, pos) {
    var $pos = view.state.doc.resolve(pos);
    if ($pos.node().type.name === const_1.NODE_NAME.DOC) {
        var nodeBefore = $pos.nodeBefore, nodeAfter = $pos.nodeAfter;
        if (checkIsRawBlock(nodeBefore) && checkIsRawBlock(nodeAfter)) {
            var dispatch = view.dispatch, state = view.state;
            var tr = state.tr.insert(pos, state.schema.nodes[const_1.NODE_NAME.P].create());
            tr = tr.setSelection(prosemirror_state_1.TextSelection.create(tr.doc, pos + 1));
            dispatch(tr);
            view.focus();
        }
    }
};
exports.insertPWhenBlock = insertPWhenBlock;
var zeroRegTail = /\u200B+$/;
var zeroRegHead = /^\u200B+/;
var doPassZeroTr = function (direction, view) {
    var decorationState = decoration_1.DecoKey.getState(view.state);
    var decorations = decorationState.find(undefined, undefined, function (spec) { return spec.shadowType === 'inline'; });
    var _a = view.state.selection, $from = _a.$from, empty = _a.empty;
    var passNode = direction > 0 ? $from.nodeAfter : $from.nodeBefore;
    if (!passNode || !passNode.isText)
        return false;
    var reg = direction > 0 ? zeroRegHead : zeroRegTail;
    var matchRes = passNode.textContent.match(reg);
    if (!matchRes)
        return false;
    var dispatch = view.dispatch, state = view.state;
    var newPos = direction > 0 ? $from.pos + matchRes[0].length : $from.pos - matchRes[0].length + (empty ? 0 : 1);
    var preventDefault = false;
    if (empty &&
        decorations.some(function (_a) {
            var from = _a.from;
            return (newPos < from && $from.pos > from) || (newPos > from && $from.pos < from);
        })) {
        preventDefault = true;
    }
    dispatch(state.tr.setSelection(prosemirror_state_1.TextSelection.create(state.doc, newPos)));
    return preventDefault;
};
var passZeroWidthChar = function (_a) {
    var view = _a.view, event = _a.event;
    var keyCode = event.keyCode, which = event.which, key = event.key;
    if (keyCode === 39 || which === 39 || key === 'ArrowRight') {
        // 右箭头
        return doPassZeroTr(1, view);
    }
    else if (keyCode === 37 || which === 37 || key === 'ArrowLeft') {
        // 左箭头
        return doPassZeroTr(-1, view);
    }
    return false;
};
exports.passZeroWidthChar = passZeroWidthChar;
var createPlaceHolder = function (placeholder) {
    return function (view) {
        var span = document.createElement('span');
        span.classList.add('syl-placeholder');
        var parent = view.state.selection.$from.parent;
        var styleText = 'cursor: text; user-select: none;text-indent: initial;';
        if ((!browser_1.browser.android && !browser_1.browser.ios && !browser_1.browser.mac) || (browser_1.browser.mac && browser_1.browser.chrome)) {
            styleText += ' position: absolute;';
        }
        if (parent.attrs.align === 'right') {
            var paddingRight = parseInt(window.getComputedStyle(view.dom).paddingRight, 10);
            styleText += " right: " + paddingRight + "px";
        }
        else if (parent.attrs.align === 'center') {
            styleText += " transform: translateX(-50%);";
        }
        span.setAttribute('style', styleText);
        span.setAttribute('ignoreel', 'true');
        span.addEventListener('click', function () { return view.focus(); });
        span.innerHTML = placeholder;
        return span;
    };
};
exports.createPlaceHolder = createPlaceHolder;
//# sourceMappingURL=utils.js.map